import { loadPdfDocumentLogo } from "../pdf/pdfDocumentLogo";
import type { WorkbookLogo } from "./documentWorkbook";

/** Reuses the PDF cover asset and normalizes it to PNG for Excel's native drawing layer. */
export async function loadExcelDocumentLogo(source: string): Promise<WorkbookLogo> {
  const image = await loadPdfDocumentLogo(source) ?? await loadPdfDocumentLogo("/images/logo-detail-small-2.png");
  if (!image) throw new Error("Das Dokumentlogo konnte nicht geladen werden.");
  return rasterizeExcelImage(image);
}

/** Device images must never fall back to the document logo. */
export async function loadExcelFrontImage(source: string): Promise<WorkbookLogo | undefined> {
  const image = await loadPdfDocumentLogo(source);
  return image ? rasterizeExcelImage(image) : undefined;
}

function rasterizeExcelImage(image: HTMLImageElement): WorkbookLogo {
  const width = image.naturalWidth || image.width;
  const height = image.naturalHeight || image.height;
  const scale = Math.min(1, 256 / Math.max(width, height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(width * scale));
  canvas.height = Math.max(1, Math.round(height * scale));
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Das Dokumentlogo konnte nicht aufbereitet werden.");
  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  const base64 = canvas.toDataURL("image/png").split(",")[1];
  return { bytes: Uint8Array.from(atob(base64), character => character.charCodeAt(0)), width: canvas.width, height: canvas.height };
}
